import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (id: any) => {
  return httpRequest.get(`/inv/invoice/${id}`);
};

export const pay = async (data: any) => {
  return httpRequest.post(`/pay/invoice`, data);
};

// Spec §2.2 — invoice PDF download. /inv/invoice/:id/pdf is an AUTHENTICATED
// JSON route: it renders the invoice, hands the HTML to the media service, and
// returns the resulting PDF file URL. It does NOT stream a PDF. So we must call
// it through HttpRequest (which attaches the bearer token) and then open the
// URL it returns — opening the API path directly in a new tab yields a blank
// page (a raw navigation carries no Authorization header, and the body is JSON).
export const getPdf = async (id: string): Promise<string> => {
  const res = await httpRequest.get<string | { url: string }>(`/inv/invoice/${id}/pdf`);
  return typeof res === "string" ? res : res?.url;
};

export type ReceivedInvoiceSummary = {
  count: number;
  receivableCount: number;
  amountToPay: number;
  overdueCount: number;
  overdueAmount: number;
};

/**
 * GET /inv/invoice/received (INV_LIST): invoices sent to the caller's business, newest
 * first, with a whole-set summary (to pay, overdue). `senderBusinessId` narrows to one
 * supplier; `status: "CONFIRMED"` keeps the ones the buyer still has to pay.
 */
export const received = async (params: {
  filter: { status?: string; senderBusinessId?: string; due?: "overdue" | "week" | "none" };
  offset: { page: number; limit: number };
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpRequest.get<{ count: number; rows: any[]; summary: ReceivedInvoiceSummary }>("/inv/invoice/received", params as any);
};
